/* Entry file for the site */

'use strict';
/**
 * max scale hack for IOS to prevent auto zooming
 */
if (navigator.userAgent.indexOf('iPhone') > -1) {
	document
		.querySelector('[name=viewport]')
		.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
}

//Core Alpine Library
import Alpine from 'alpinejs';

import 'what-input';
import './components/modal-dialog.js';
import './components/x-close.js';
import './components/x-youtube.js';
import './components/x-store-reviews-teaser.js';
import './components/x-media-stream-player.js';

import './components/bootstrap/add-variable-for-header-promo.js';

/*********************************/
/** BEGIN: Alpine bootstrap **/
/*********************************/
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import persist from '@alpinejs/persist';
import mask from '@alpinejs/mask';
import morph from '@alpinejs/morph';
import AsyncAlpine from 'async-alpine';

/** this must be the last declaration **/
Alpine.plugin(AsyncAlpine);
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(mask);
Alpine.plugin(morph);

/** START: Global Bootstrap Components */
import PredictiveSearch from './components/bootstrap/predictive-search';
Alpine.plugin(PredictiveSearch);

import CartStore from './components/bootstrap/cart/store';
Alpine.plugin(CartStore);

import LocationStore from './components/bootstrap/location/store';
Alpine.plugin(LocationStore); //TODO

/** END: Global Bootstrap Components */

//bind alpine object to the window for re-use globally
window['Alpine'] = Alpine;

document.addEventListener('DOMContentLoaded', function () {
	window['CM'] = window['CM'] || {};
	window['Alpine'].start();
});
